import styled from 'styled-components';

import { 
  PADDING_CONTENT_PAGE, BACKGROUND_TABLE_TIMES, BACKGROUND_TABLE_TIMES_HOVER, BORDER_COLOR_TABLE_TIMES,
  FONT_SIZE_TABLE_TIMES_ROW, FONT_SIZE_TABLE_TIMES_HEADER, COLOR_TABLE_TIMES_FULL, COLOR_TABLE_TIMES_HOVER,
} from '../../../globals';


export const StyledTableTimes = styled.div`
  .table-times-error {
    position: relative;
    height: 150px;
  }

  .table-times {
    //width: 100%;
    margin: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  }

  .table-times-header {   
     font-size: ${FONT_SIZE_TABLE_TIMES_HEADER}em;
     font-weight: 700;
  }

  tr {
    border-top: 4px solid white;
    border-bottom: 4px solid white;
  }

  .table-times-row {
    width: 100%;
    background-color: ${BACKGROUND_TABLE_TIMES};
    font-size: ${FONT_SIZE_TABLE_TIMES_ROW}em;
    cursor: pointer;
  }

  .table-times-row-free {

  }

  .table-times-row-full {
    color: ${COLOR_TABLE_TIMES_FULL};
  }

  .table-times-row-free:hover {
    background-color: ${BACKGROUND_TABLE_TIMES_HOVER};
    color: ${COLOR_TABLE_TIMES_HOVER};
  }

  td {
     padding: 6px 0px 6px 0px;
  }

  .table-times-div-time {
    text-align: left;
    border-right: 1px solid ${BORDER_COLOR_TABLE_TIMES};
    padding: 0px 15px 0px 15px;
    width: 75px;
  }

  .table-times-col-time {

  }

  .table-times-td-capacity {
    text-align: left;
    width: 100%;
    padding: 0px 15px 0px 15px;
  }

  .table-times-td-arrow {
    text-align: center;
    vertical-align: middle;
    font-size: 15px;
    padding: 0px 15px 0px 15px;
  }

  @media (max-width: 1199px) {
    .interbals-table-header-disable-medium {
      display: none;
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/components/IntervalsContent/styles/StyledTableTimes.js